/**
 * Merge objects together, with the latter object taking precedence
 */
export const mergeObjects = <TObj extends {}>(obs: TObj[], initial: TObj): TObj =>
  obs.reduce<TObj>((acc, current) => ({ ...acc, ...current }), initial);
